import { useAttributes } from "@/features/auth/hooks/useAttributes";
import { useMemo } from "react";

const useZendeskDomain = (): string | null => {
  const attributes = useAttributes();
  const zendeskDomain =
    attributes?.zendeskDomainTemp || attributes?.zendeskDomain;
  // fall back to the env file for now
  if (zendeskDomain === "" || typeof zendeskDomain === "undefined") {
    return process.env.GATSBY_ZENDESK || null;
  }
  return zendeskDomain;
};

const useZendeskKey = (): string | null => {
  const attributes = useAttributes();
  const zendeskKey = attributes?.zendeskKeyTemp || attributes?.zendeskKey;
  // fall back to the env file for now
  if (zendeskKey === "" || typeof zendeskKey === "undefined") {
    return process.env.GATSBY_ZENDESK_KEY || null;
  }
  return zendeskKey;
};

const useZendeskMessengerToken = (): string | null => {
  const attributes = useAttributes();
  return attributes?.zendeskMessengerToken ?? null;
};

/**
 * Handles clicks on banners and promotions. Extended to detect `data-helpcenter`
 * attributes since banners/promotions do not pass href which can be handled
 * for Zendesk domains in HelpCenter
 */
const useHelpcenterAttributes = () => {
  const zendeskDomain = useZendeskDomain();

  const zendeskDomains = useMemo(() => {
    return [
      "picklebettest.zendesk.com",
      "help.picklebet.com",
      zendeskDomain,
    ].filter((domain) => typeof domain === "string");
  }, [zendeskDomain]);

  const isZendeskUrl = (url: string | undefined): boolean => {
    if (!url) return false;
    return zendeskDomains.some((domain) => url.includes(domain));
  };

  const getHelpcenterAttributes = (url: string | undefined) => {
    return isZendeskUrl(url) ? { "data-helpcenter": url } : {};
  };

  return {
    zendeskDomains,
    isZendeskUrl,
    getHelpcenterAttributes,
  };
};

export {
  useZendeskDomain,
  useZendeskKey,
  useZendeskMessengerToken,
  useHelpcenterAttributes,
};
